export default __webpack_public_path__ + "static/media/russia.ccc89412.png";